import React from "react";
import GymNavigation from "../GymNavigation";
import Box from "components/UI/Box";
import Button from "components/UI/Button";
import SlideSwitch from "components/SlideSwitch";
import "./style.css";
import moment from "moment";
import { toast } from "react-toastify";
import axios from "axios";
import { API_URL, ERROR_HANDLE } from "config/constants";

const tableBody = (data) => {
  if (data) {
    if (data.length > 0) {
      return data.map((currentItem, index, arr) => {
        return (
          <div key={index}>
            <div  key={index} className="div_ActiveUsers_userData">
              <div>
                <p>{currentItem.name}</p>
              </div>
              <div>
                <p>
                  {currentItem.trainers_gyms.joined_date ? moment(currentItem.trainers_gyms.joined_date).format("MM/DD/YY"): ""}
                </p>
              </div>
              <div>
                <p>
                  {currentItem.onboarding_status}
                </p>
              </div>
              <div>
                <p>
                {currentItem.sessions}
                </p>
              </div>
            </div>
          </div>
        );
      });
    } else return <p>No Trainers yet</p>;
  }
};

const renderHeader = (trainers) => {
  if(trainers && trainers.length > 0)
  return (
    <div className="div_ActiveUsers_userData">
      <div>
        <p style={style.titleText}>Trainers</p>
      </div>
      <div>
        <p style={style.titleText}>Added Date</p>
      </div>
      <div>
        <p style={style.titleText}>Status</p>
      </div>
      <div>
        <p style={style.titleText}>Sessions</p>
      </div>
    </div>
  )
}

class Trainers extends React.Component {
  state = {
    is_trainer_enabled: this.props.gym.is_trainer_enabled
  };
  handleSlideSwitch = () => {
    const access_token = localStorage.getItem("access_token");
    axios
      .post(
        `${API_URL}/admin/gyms/changeTrainerEnablement/${this.props.gym.gym_id}`,
        { status: !this.state.is_trainer_enabled },
        {
          headers: {
            "x-access-token": access_token
          }
        }
      )
      .then(res => {
        this.props.gym.is_trainer_enabled = this.state.is_trainer_enabled
        toast("Trainer Enablement Status Changed", { autoClose: 500 });
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
    this.setState({ is_trainer_enabled: !this.state.is_trainer_enabled });
  };
  componentWillReceiveProps(nextProps) {
    if (nextProps.is_trainer_enabled !== this.props.is_trainer_enabled) {
      this.setState({
        is_trainer_enabled: nextProps.is_trainer_enabled
      });
    }
  };

  render() {
    const { trainers } = this.props;
    return (
      <React.Fragment>
        <GymNavigation />
        <div style={style.wrapper}>
          <Box outline style={style.box}>
            <div style={style.header}>
              <div style={{fontWeight : "bold", fontSize: '20px'}}>PERSONAL TRAINING (BETA)</div>
              <div>
                  <p style={{margin:'2px'}}>Active</p>
                  <SlideSwitch
                    checked={this.state.is_trainer_enabled}
                    onClick={this.handleSlideSwitch}
                  />
              </div>
            </div>
            {
              this.state.is_trainer_enabled &&
              <div>
                {renderHeader(trainers)}
                {tableBody(trainers, this.setSelectedUserIndex)}
              </div>
            }
          </Box>
        </div>
      </React.Fragment>
    );
  }
}

export default Trainers;

const style = {
  wrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "10px"
  },
  box: {
    width: "900px",
    padding: '30px',
    margin: '30px'
  },
  titleText: {
    fontSize: "25px",
    color: "#00b4d2  "
  },
  header: {
    display:'flex',
    flex:1,
    flexDirection: 'row',
    alignItems:'center',
    justifyContent:'space-around'
  }
};
